import { PropTypes } from 'prop-types';
import React, {
  useState, useEffect,
  useMemo,
} from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import Helpers from '@Apis/helpers';
import closeIcon from '@Images/icons/icon-close-blue.png';
import searchIcon from '@Images/icons/icon-search.png';
import EinvoiceEwaybillIntegrationActions from '@Actions/integrations/einvoiceEwaybillActions';
import {
  Button,
  Drawer, Dropdown, Select, Table, Tag, Popconfirm,
  Tooltip,
  Divider,
} from 'antd';
import H3DateSelector from '@Uilib/h3DateSelector';
import { FilterOutlined, SettingOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import { v4 as uuidv4 } from 'uuid';
import AuthDrawer from './AuthDrawer';
import EwaybillForm from './EwaybillForm';
import ViewEwayBill from './ViewEwayBill';
import HideValue from '../../../Common/RestrictedAccess/HideValue';
import PRZText from '../../../Common/UI/PRZText';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import './style.scss';
import PRZSelect from '../../../Common/UI/PRZSelect';
import { dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums } from '../../../../apis/constants';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';

const { Option } = Select;

const EwaybillList = ({
  user, history, getEwaybills, eWaybills, getEwaybillsLoading, excludeEwayBills, excludeEwayBillsLoading, MONEY, priceMasking,
}) => {
  const ewaybillStatuses = [
    { value: 'GENERATED', label: 'Generated' },
    { value: 'NOT_GENERATED', label: 'Not Generated' },
    { value: 'EXPIRED', label: 'Expired' },
    { value: 'CANCELLED', label: 'Cancelled' },
    { value: 'EXCLUDED', label: 'Excluded' },
  ];

  const [showAuthDrawer, setShowAuthDrawer] = useState(false);
  const [showCreateDrawer, setShowCreateDrawer] = useState(false);
  const [showViewDrawer, setShowViewDrawer] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');
  const [doctype, setDoctype] = useState('INV');
  const [selectedStatus, setSelectedStatus] = useState('GENERATED');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedTenant, setSelectedTenant] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [ewaybill, setEwaybill] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [call, setCall] = useState(false);

  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const [eWayBillDateSelectedIntervalDateRangeType, setEWayBillDateSelectedIntervalDateRangeType] = useState('');

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const { isDataMaskingPolicyEnable, isHideSellingPrice } = priceMasking;

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit')) || limit,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'doc_type',
        filter_value: Helpers.getValueFromUrl('doc_type') || 'INV',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'status',
        filter_value: Helpers.getValueFromUrl('status') || 'GENERATED',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'from_date',
        filter_value: Number(Helpers.getValueFromUrl('from_date')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('e_way_bill_date_type') || '',
      },
      {
        filter_key: 'to_date',
        filter_value: Number(Helpers.getValueFromUrl('to_date')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('e_way_bill_date_type') || '',
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => [
    {
      filter_key: 'limit',
      filter_value: limit,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'keyword',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'doc_type',
      filter_value: 'INV',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'status',
      filter_value: 'GENERATED',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'from_date',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'to_date',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'tenant',
      filter_value: [user?.tenant_info?.tenant_id],
      filter_type: filterTypeEnums.ARRAY,
    },
  ], []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.E_WAY_BILL,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  const getEwaybillColumns = () => {
    const columns = [
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <Link
                  // to={
                  //   doctype === 'INV' ? `/sales/invoice/view/${record?.document_id}`
                  //     : (doctype === 'CNT' ? `/sales/credit-note/view/${record?.document_id}` : `/inventory/delivery-challan/view/${record?.document_id}`)
                  // }
                  // target="_blank"
                >
                  <PRZText
                    text={record?.document_number}
                    className="mobile-list__card_item-number"
                  />
                </Link>
              </div>
              <div className="mobile-list__card_header-right">
                <div />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                <div className="mobile-list__card_item-name_wrapper">
                  <Tooltip
                    title={`${record?.customer_info?.internal_cust_code || ''}  ${record?.customer_info?.customer_name}`}
                    color="white"
                  >
                    <PRZText
                      text={`${record?.customer_info?.internal_cust_code || ''}  ${record?.customer_info?.customer_name}`}
                      className="mobile-list__card_item-name"
                    />
                  </Tooltip>
                </div>

                <PRZText text={`Document Date: ${dayjs(record?.document_date)?.format('DD/MM/YYYY')}`} className="mobile-list__card_item-details" />

                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text={`${record?.tenant_name} ( ${record?.department_name} )`}
                    />
                  )}
                  color="white"
                >
                  <PRZText text={`Location: ${record?.tenant_name} (${record?.department_name})`} className="mobile-list__card_item-details" />
                </Tooltip>

                <PRZText text={`GSTIN: ${record?.customer_info?.gst_number || '-'}`} className="mobile-list__card_item-details" />

                <PRZText text={`EWB Date: ${record?.created_at ? dayjs(record?.created_at)?.format('DD/MM/YYYY') : '-'}`} className="mobile-list__card_item-details" />

              </div>
              <div className="mobile-list__card_body-right">
                <Tooltip
                  color="white"
                  title={(
                    <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text="Amount" />
                  )}
                >
                  <PRZText
                    text={(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view amount" /> : MONEY(record?.document_total)}
                    className="mobile-list__card_item-details"
                  />
                </Tooltip>
              </div>
            </div>

            <Divider className="mobile-list__card_divider" />

            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-left">
                <div className="mobile-list__card_footer__other-multi-status__wrapper">
                  {record?.ewb_no === null && (<Tag color="gold">Not Generated</Tag>)}
                  {record?.ewb_no && record?.expires_at && dayjs(record?.expires_at) < dayjs() && <Tag color="red">Expired</Tag>}
                  {record?.status === 'CANCELLED' && <Tag color="red">Cancelled</Tag>}
                  {record?.status === 'GENERATED' && <Tag color="green">Generated</Tag>}
                </div>

              </div>
              <div className="mobile-list__card_footer-right">
                <div />
              </div>
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'LOCATION',
        render: (record) => (
          <div className="min-width-70">
            <H3Text text={record?.tenant_name} />
            <H3Text text={record?.department_name} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'DOCUMENT DATE',
        render: (record) => (
          <div className="column-date min-width-100">
            <H3Text text={dayjs(record?.document_date)?.format('DD/MM/YYYY')} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'DOCUMENT NUMBER',
        render: (record) => (
          <div className="associated-entity min-width-115">
            <Link
              to={
                doctype === 'INV' ? `/sales/invoice/view/${record?.document_id}`
                  : (doctype === 'CNT' ? `/sales/credit-note/view/${record?.document_id}` : `/inventory/delivery-challan/view/${record?.document_id}`)
              }
              target="_blank"
            >
              {record?.document_number}
            </Link>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'CUSTOMER',
        render: (record) => (
          <div className="min-width-70">
            <H3Text text={`${record?.customer_info?.internal_cust_code || ''}  ${record?.customer_info?.customer_name}`} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'GSTIN',
        render: (record) => (
          <div className="min-width-50">
            <H3Text text={record?.customer_info?.gst_number} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'EWB NUMBER',
        render: (record) => (
          <div className="min-width-85">
            <H3Text text={record?.ewb_no} />
            {record?.ewb_no === null && (<Tag color="gold">Not Generated</Tag>)}
            {record?.ewb_no && record?.expires_at && dayjs(record?.expires_at) < dayjs() && <Tag color="red">Expired</Tag>}
            {record?.status === 'CANCELLED' && <Tag color="red">Cancelled</Tag>}
            {record?.status === 'GENERATED' && <Tag color="green">Generated</Tag>}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'EWB DATE',
        render: (record) => (
          <div className="column-date min-width-70">
            {record?.created_at ? <H3Text text={dayjs(record?.created_at)?.format('DD/MM/YYYY')} /> : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'AMOUNT',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (item, record) => (
          <div className="column-amount min-width-70">
            {(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view amount"} /> : MONEY(record?.document_total)}
          </div>
        ),
      },
      {
        title: '',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isPortrait,
        key: 'action',
        fixed: 'right',
        className: 'list__actions-column',
        render: (item, record) => (
          <div className="list__actions">
            <div
              className="list__actions-button list__actions-button-dark"
              onClick={() => {
                if (record?.ewb_no === null) {
                  setShowCreateDrawer(true);
                  setEwaybill(record);
                } else {
                  setShowViewDrawer(true);
                  setEwaybill(record);
                }
              }}
            >
              {record?.ewb_no === null ? '+ e-Way Bill' : 'View'}
            </div>
          </div>

        ),
      },
    ];
    return columns.filter((item) => !item.hidden);
  };
  const pushParamsToUrl = (page, pgSize, word, currentTenant, doctype, status, fromDate, toDate, eWayBillDateRangeType, selectedFilterView) => {
    // limit, page, keyword, tenantId, doctype, status
    let url = '';
    if (page) url += `?page=${page}&`;
    if (pgSize) url += `limit=${pgSize}&`;
    if (word) url += `keyword=${word}&`;
    if (doctype) url += `doc_type=${doctype}&`;
    if (status) url += `status=${status}&`;
    if (fromDate) url += `from_date=${fromDate}&`;
    if (toDate) url += `to_date=${toDate}&`;
    if (eWayBillDateRangeType) url += `e_way_bill_date_type=${eWayBillDateRangeType}&`;
    if (currentTenant) url += `tenant=${currentTenant}&`;
    if (selectedFilterView) url += `filter_id=${selectedFilterView?.filter_id}&`;
    history.push(url);
  };

  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      // setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
      // setSearchKeyword(Helpers.getValueFromUrl('keyword'));
      // setKeyword(Helpers.getValueFromUrl('keyword'));
      // setSelectedStatus(Helpers.getValueFromUrl('status') || selectedStatus);
      // setStartDate(Number(Helpers.getValueFromUrl('from_date')));
      // setEndDate(Number(Helpers.getValueFromUrl('to_date')));
      // setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [user?.tenant_info?.tenant_id]);
      // setIsUserReady(true);
      setSelectedFilterView(systemDefaultUserView);
    }
  }, []);

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        const _orderDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'from_date', valueOnly: false }).date_range_type;

        let _orderStartDate = '';
        let _orderEndDate = '';

        if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_orderDateRangeType);
          const [start, end] = date;

          _orderStartDate = start;
          _orderEndDate = end;
          filterValue.from_date = _orderStartDate;
          filterValue.to_date = _orderEndDate;
        }

        filterValue.eWayBillDateRangeType = _orderDateRangeType;

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setSelectedStatus(tempFilterValues.status);
        setSelectedTenant(tempFilterValues.tenant);
        setStartDate(tempFilterValues.from_date);
        setEndDate(tempFilterValues.to_date);
        setEWayBillDateSelectedIntervalDateRangeType(tempFilterValues.eWayBillDateRangeType);
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, searchKeyword, selectedTenant, doctype, selectedStatus, startDate, endDate, eWayBillDateSelectedIntervalDateRangeType, selectedFilterView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getEwaybills(Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'), Helpers.getValueFromUrl('keyword'), selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ)?.join(','), Helpers.getValueFromUrl('doc_type'), Helpers.getValueFromUrl('status'), Number(Helpers.getValueFromUrl('from_date')), Number(Helpers.getValueFromUrl('to_date')));
    }
  }, [currentPage, limit, searchKeyword, selectedStatus, doctype, selectedTenant, startDate, endDate, call, eWayBillDateSelectedIntervalDateRangeType,
    // selectedFilterView
  ]);

  const documentOptions = [
    { value: "INV", label: "Invoice" },
    { value: "CHL", label: "Delivery Challan" },
    { value: "CNT", label: "Credit Note" },
  ];

  return (
    <div>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24 ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for ewaybills"
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                {user?.org_id && (
                  <div
                    onClick={() => setShowAuthDrawer(true)}
                    className="ewaybill__reconfigure-button"
                  >
                    <SettingOutlined />
                    <span>Change e-way bill portal settings</span>
                  </div>
                )}
              </div>
            </div>
            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const _orderDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'from_date', valueOnly: false }).date_range_type;

                    let _orderStartDate = '';
                    let _orderEndDate = '';

                    if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
                      // No action needed for empty or custom date range type
                    } else {
                      const date = dateRangePresetsValues(_orderDateRangeType);
                      const [start, end] = date;

                      _orderStartDate = start;
                      _orderEndDate = end;
                      filterValue.from_date = _orderStartDate;
                      filterValue.to_date = _orderEndDate;
                    }

                    filterValue.eWayBillDateRangeType = _orderDateRangeType;

                    const tempFilterValues = filterValue;

                    setCurrentPage(1);
                    setLimit(tempFilterValues.limit || limit);
                    setSearchKeyword(tempFilterValues.keyword);
                    setKeyword(tempFilterValues.keyword);
                    setSelectedStatus(tempFilterValues.status);
                    setSelectedTenant(tempFilterValues.tenant);
                    setStartDate(tempFilterValues.from_date);
                    setEndDate(tempFilterValues.to_date);
                    setEWayBillDateSelectedIntervalDateRangeType(tempFilterValues.eWayBillDateRangeType);

                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.E_WAY_BILL}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                    Search for
                    &nbsp;
                    <span><b>{searchKeyword}</b></span>
                  </Tag>
                )}
                {selectedStatus && (
                  <Tag color="#2d7df7">
                    Status -
                    &nbsp;
                    <span><b>{selectedStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {selectedStatus && (
                  <Tag color="#2d7df7">
                    Document Type -
                    &nbsp;
                    <span><b>{doctype === 'INV' ? 'INVOICE' : (doctype === 'CHL' ? 'DELIVERY CHALLAN' : 'CREDIT NOTE')}</b></span>
                  </Tag>
                )}
                {
                  (startDate && endDate) ? (
                    <Tag
                      closable
                      onClose={() => {
                        setStartDate(null);
                        setEndDate(null);
                        setEWayBillDateSelectedIntervalDateRangeType('');
                      }}
                      color="#2d7df7"
                    >
                      {' '}
                      From:
                      &nbsp;
                      <span><b>{dayjs(startDate).format('DD/MM/YYYY')}</b></span>
                      &nbsp;
                      To:
                      &nbsp;
                      <span><b>{dayjs(endDate).format('DD/MM/YYYY')}</b></span>
                    </Tag>
                  ) : ''
                }
                {selectedTenant && selectedTenant?.map((item, index) => (
                  <Tag
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                    key={item?.tenant_id}
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
              </div>
            </div>
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      <H3Text text={`${(eWaybills && eWaybills?.count) ? eWaybills?.count : '0'} e-Way Bills`} className="" />
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">
                        {selectedRows?.length > 0 && ['NOT_GENERATED', 'EXCLUDED'].includes(selectedStatus) && (
                          <Popconfirm
                            placement="bottom"
                            title={`Are you sure you want to ${selectedStatus === 'EXCLUDED' ? 'include' : 'exclude'} these documents?`}
                            onConfirm={() => {
                              const payload = [];
                              for (let i = 0; i < selectedRows?.length; i++) {
                                payload.push({
                                  document_id: selectedRows[i]?.document_id,
                                  document_type: doctype,
                                  exclude_from_e_way: selectedStatus !== 'EXCLUDED',
                                });
                              }
                              excludeEwayBills(payload, () => {
                                setCall(!call);
                                setSelectedRows([]);
                                setSelectedRowKeys([]);
                              });
                            }}
                          >
                            <Button type="default" className="ewaybill__exclude-button" loading={excludeEwayBillsLoading}>
                              {selectedStatus === 'EXCLUDED' ? 'Include' : 'Exclude'}
                            </Button>
                          </Popconfirm>
                        )}
                        <H3DateSelector
                          selectedInterval={eWayBillDateSelectedIntervalDateRangeType}
                          startDate={startDate}
                          endDate={endDate}
                          onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                            setStartDate(dayjs(date[0])?.startOf('day').valueOf());
                            setEndDate(dayjs(date[1])?.endOf('day').valueOf());
                            setCurrentPage(1);
                            setEWayBillDateSelectedIntervalDateRangeType(dateRangeType);
                          }}
                        />
                      </div>
                      <Dropdown
                        trigger={['click']}
                        overlay={(
                          <div className="header__filter__container">
                            <div className="header__filter__container__title">
                              Apply Filters
                            </div>
                            <div className="filter__container">
                              <div className="filter__title"> Select Business Unit </div>
                              <TenantSelector
                                selectedTenant={selectedTenant}
                                showSearch
                                isMultiple
                                noDropdownAlign
                                onChange={(value) => {
                                  setCurrentPage(1);
                                  setSelectedTenant(value);
                                }}
                                placeholder="Select Business Unit"
                                hideTitle
                                includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ)}
                              />
                            </div>
                            <div className="filter__container">
                              <div className="filter__title"> Ewaybill Status </div>
                              <PRZSelect
                                value={selectedStatus}
                                onChange={(value) => {
                                  setSelectedStatus(value);
                                  setSelectedRowKeys([]);
                                  setSelectedRows([]);
                                  setCurrentPage(1);
                                }}
                                placeholder="Status"
                                options={ewaybillStatuses}
                              />
                            </div>
                            <div className="filter__container">
                              <div className="filter__title">Document Type</div>
                              <PRZSelect
                                value={doctype}
                                onChange={(value) => {
                                  setDoctype(value);
                                  setCurrentPage(1);
                                }}
                                placeholder="document type.."
                                options={documentOptions}
                              />
                            </div>

                          </div>
                        )}
                      >
                        <div className="doc-list__action-buttons">
                          <div className="action-button">
                            <H3Text text="Filters" className="action-button-text" />
                            <FilterOutlined />
                          </div>
                        </div>
                      </Dropdown>
                    </div>
                  </div>
                )}
                loading={getEwaybillsLoading || excludeEwayBillsLoading || savedFilterViewsLoading}
                showHeader
                size="small"
                scroll={!isMobileOrPortrait && !!eWaybills?.e_way_bills?.length ? { x: 'max-content', y: 'calc(100dvh - 160px)' } : { x: 'max-content' }}
                sticky={!isMobileOrPortrait && !!eWaybills?.e_way_bills?.length}
                columns={getEwaybillColumns()}
                dataSource={eWaybills?.e_way_bills || []}
                rowKey="document_id"
                pagination={
                  {
                    defaultCurrent: currentPage,
                    current: currentPage,
                    total: eWaybills ? eWaybills?.count : 0,
                    pageSize: limit,
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setLimit(pageSize);
                    },
                    position: ['bottomLeft'],
                    showSizeChanger: true,
                    pageSizeOptions: [10, 25, 50, 100],
                  }
                }
                rowSelection={(!isMobileOrPortrait && ['NOT_GENERATED', 'EXCLUDED'].includes(selectedStatus)) ? {
                  onChange: (rowKeys, rows) => {
                    setSelectedRowKeys(rowKeys);
                    setSelectedRows(rows);
                  },
                  selectedRowKeys,
                } : false}
              />
            </div>
          </div>
        </div>
      </div>
      <Drawer
        open={showAuthDrawer}
        width="450px"
        mask
        onClose={() => setShowAuthDrawer(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '405px' }}>
            <H3Text text="Update GST Credentials" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowAuthDrawer(false)} />
          </div>
        </div>
        <AuthDrawer />
      </Drawer>
      <Drawer
        open={showViewDrawer}
        width="720px"
        mask
        onClose={() => setShowViewDrawer(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header">
            <H3Text text="View e-Way Bill Details" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowViewDrawer(false)} />
          </div>
        </div>
        <ViewEwayBill
          selectedEwaybill={ewaybill}
          callback={() => {
            setShowViewDrawer(false);
            setCall(!call);
          }}
          isQuickView
        />
      </Drawer>
      <Drawer
        open={showCreateDrawer}
        width="520px"
        mask
        onClose={() => setShowCreateDrawer(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '475px' }}>
            <H3Text text="Create e-Way Bill" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowCreateDrawer(false)} />
          </div>
        </div>
        <EwaybillForm
          drawermode
          selectedDocument={ewaybill}
          selectedDocType={doctype}
          documentDate={ewaybill?.document_date}
          selectedDocumentId={ewaybill?.document_id}
          selectedDocumentNumber={ewaybill?.document_number}
          callback={() => {
            getEwaybills(Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'), Helpers.getValueFromUrl('keyword'), selectedTenant, Helpers.getValueFromUrl('doc_type'), Helpers.getValueFromUrl('status'), Number(Helpers.getValueFromUrl('from_date')), Number(Helpers.getValueFromUrl('to_date')));
            setShowCreateDrawer(false);
          }}
          showDocumentInfo
        />
      </Drawer>
    </div>
  );
};

const mapStateToProps = ({
  UserReducers, EinvoiceEwaybillReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  eWaybills: EinvoiceEwaybillReducers.eWaybills,
  getEwaybillsLoading: EinvoiceEwaybillReducers.getEwaybillsLoading,
  excludeEwayBillsLoading: EinvoiceEwaybillReducers.excludeEwayBillsLoading,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getEwaybills: (page, limit, keyword, tenantId, doctype, status, fromDate, toDate) => dispatch(EinvoiceEwaybillIntegrationActions.getEwaybills(page, limit, keyword, tenantId, doctype, status, fromDate, toDate)),
  excludeEwayBills: (payload, callback) => dispatch(EinvoiceEwaybillIntegrationActions.excludeEwayBills(payload, callback)),
});

EwaybillList.propTypes = {
  user: PropTypes.any,
  history: PropTypes.func,
  getEwaybills: PropTypes.func,
  eWaybills: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EwaybillList));
